// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacy[data-v-e7e0acb0] {\n  text-align: center;\n  font-size: 0.32rem;\n  font-weight: 400;\n  color: #C4C4C4;\n  margin-top: 1.06667rem;\n  margin-bottom: 0.53333rem;\n  text-decoration-line: underline;\n}\n", ""]);
// Exports
module.exports = exports;
